import { cachedGetUniqueQueryParams, getUniqueQueryParams } from '../../shared/customReports/helpers';
import { CustomReportParamTypes } from '../../shared/customReports/constants';

export const getInitialStateFromReport = customReport => {
  if (!customReport) {
    return {};
  }

  const filteredParams = customReport.params
    ? Object.values(customReport.params).filter(param => param.type !== CustomReportParamTypes.validator)
    : [];

  return {
    mapping: null,
    uniqueParams: filteredParams,
  };
};

export const getInitialStateFromReportSet = customReports => {
  if (!customReports) {
    return {
      queryParams: null,
      mapping: null,
      uniqueParams: null,
    };
  }

  const { queryParams, paramToUniqueIdMapping, uniqueParams } = cachedGetUniqueQueryParams(customReports);

  return {
    queryParams,
    mapping: paramToUniqueIdMapping,
    uniqueParams,
  };
};

export const getStateFromReport = customReport => {
  if (!customReport) {
    return {
      queryParams: null,
      mapping: null,
      uniqueParams: null,
    };
  }

  const filteredParams = customReport.params
    ? Object.values(customReport.params).filter(param => param.type !== CustomReportParamTypes.validator)
    : [];

  const queryParams = customReport.params
    ? Object.values(customReport.params)
      .filter(param => param.type !== CustomReportParamTypes.validator)
      .reduce((acc, paramDefinition) => ({
        ...acc,
        [paramDefinition.name]: '',
      }), {})
    : {};

  return {
    queryParams,
    mapping: null,
    uniqueParams: filteredParams,
  };
};

export const getStateFromReportSet = customReports => {
  if (!customReports) {
    return {};
  }

  const { queryParams, paramToUniqueIdMapping, uniqueParams } = getUniqueQueryParams(customReports);

  return {
    queryParams,
    mapping: paramToUniqueIdMapping,
    uniqueParams,
  };
};
